import $ from "jquery";


class JuryCarousel {
  constructor() {
    this.events();
  }

  events() {
    window.addEventListener('DOMContentLoaded', (event) => {

      $(".jury-carousel").owlCarousel({
        margin: 20,
        loop: true,
        autoplay: false,
        nav: true,
        autoWidth: true,
        navText: [$('.am-next'), $('.am-prev')],
        responsive: false,
        center: true
      });
    });

  }
}

export default JuryCarousel;